module.exports = __webpack_public_path__ + "resources/img/img-manufacturing-fems-en.6bc9806b8e24b9d8c6d525d77ccb9a14.png";